export default __webpack_public_path__ + "static/Yuniar Kurnata-bad73bc6a884c71f8ada6a0f06f5c7d7.webp";